/**
 * 验证手机号
 * @param {string} str
 * @returns {Boolean}
 */
export function checkPhone(phone) {
  return /^1[3456789]\d{9}$/.test(phone);
}

/**
 * 验证身份证号, 支持1/2代(15位/18位数字)
 * @param {string} str
 * @returns {Boolean}
 */
export function checkIdNumber(idNumber) {
  return /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/.test(
    idNumber
  );
}

/**
 * 验证账号, 帐号是否合法(字母开头，允许6-18字节，允许字母数字下划线组合）
 * @param {string} str
 * @returns {Boolean}
 */
export function checkAccount(account) {
  return /^[a-zA-Z]\w{5,17}$/.test(account);
}

/**
 * 验证账号, 是否是数字和字母
 * @param {string} str
 * @returns {Boolean}
 */
export function checkStringAndNumber(account) {
  return /^[A-Za-z0-9]+$/.test(account);
}

/**
 * 验证是否是字符串
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === "string" || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * 验证是否是数组
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }
  return Array.isArray(arg);
}

/**
 * 验证是否是字母
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * 验证是否都是小写字母
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * 验证是否都是大写字母
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * 手机号脱敏显示
 * @param {string} str
 * @returns {string}
 */
export function fillPhone(str) {
  const pat = /(\d{3})\d*(\d{4})/;
  const b = str.replace(pat, "$1****$2");
  return b;
}
